<template>
    <modal id="add-voucher" size="lg" :open="onModalOpen" :close="onModalClose" class="text-center">
        <form @submit.prevent="submit">
            <h1 class="page-title">Add promo code</h1>

            <div class="flex justify-center pt-8 pb-16">
                <div class="w-full sm:w-3/4 md:w-1/2 lg:w-2/5">
                    <label for="voucher-input" class="sr-only">Voucher Code</label>

                    <input class="form-control text-center"
                           id="voucher-input"
                           name="code"
                           v-model="code"
                           @keyup="onKeyUp"
                    />

                    <div v-if="voucherCodeError" class="form-error">{{ voucherCodeError }}</div>
                </div>
            </div>

            <div class="modal-footer">
                <button type="submit"
                        role="button"
                        class="btn btn-primary"
                        :class="{ loading: loadingVoucherCode }"
                        :disabled="loadingVoucherCode"
                >
                    <span v-if="!voucherCode">Apply</span>
                    <span v-else>Change</span>
                </button>

                <button v-if="voucherCode"
                        type="button"
                        role="button"
                        class="btn btn-secondary ml-2"
                        @click="clearVoucherCodeAndClose"
                >Remove</button>
            </div>
        </form>
    </modal>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'add-voucher',

        data() {
            return {
                code: '',
            };
        },

        computed: {
            ...mapState('appointment', [
                'appointmentData',
            ]),

            ...mapState('voucher', [
                'loadingVoucherCode',
                'voucherCode',
                'voucherCodeError',
            ]),
        },

        methods: {
            ...mapActions('voucher', [
                'getVoucherCodeDetails',
                'clearVoucherCode',
                'clearVoucherCodeError',
            ]),

            onKeyUp() {
                this.code = this.code.toUpperCase();
            },

            submit() {
                const callback = () => this.hideModal();

                const clinic = this.appointmentData.clinic;

                const code = this.code;

                this.getVoucherCodeDetails({ code, clinic, callback });
            },

            clearVoucherCodeAndClose() {
                this.code = '';

                this.clearVoucherCode();
                this.hideModal();
            },

            onModalOpen() {
                if (this.voucherCode) {
                    this.code = window._.first(this.voucherCode.codes);
                }

                setTimeout(() => this.$nextTick(document.getElementById('voucher-input').focus()), 100);
            },

            onModalClose() {
                this.code = '';

                this.clearVoucherCodeError();
            },
        },
    }
</script>
